import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  InputLabel,
  FormControl,
  TextField,
  Autocomplete,
} from "@mui/material";
import "./ApplicantDetailsDocuments.css";

import { updateSnackbar } from "../../../../_redux/SnackbarSlice";
import * as _ser from "../../../../_redux/_services/ApplicantsSlice";
import { AddDocumentsillus } from "../../../../Icons/AddDocumentsillus";
import RightSideBar from "../../../../components/Rightsidebar/RightSideBar";
import { GetUserId, getUserDetails } from "../../../../_utilities/getUserInfo";
import { defaultApplicantsData } from "../../../../_utilities/defaultfieldsModel";
import { customFieldsAsync } from "../../../../_redux/_services/UserManagerSlice";
import DocumentViewer from "../../../../components/DocumentViewer/DocumentViewer";
import {
  MAX_FILE_SIZE_MB,
  MAX_FILE_SIZE_BYTES,
} from "../../../../_utilities/constants";

import { pdfjs } from "react-pdf";

import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import * as pdfjsLib from "pdfjs-dist";

const initalState = { data: null, message: "", isloader: true };

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const AddApplicantDetailsDocuments = ({
  HandlerType,
  JobId,
  previewType,
  DocName,
  onReceivePropsHandler,
  fileExtention,
}) => {
  return (
    <div id={HandlerType === "view" ? "documentViewer" : "uploadviewer"}>
      <RightSideBar
        componentData={
          <ComponentRenderData
            JobId={JobId}
            handler={HandlerType}
            previewType={previewType}
            DocName={DocName}
            fileExtention={fileExtention}
            onReceivechildProps={onReceivePropsHandler}
          />
        }
        componentLayout={HandlerType === "view" ? pannelobjview : pannelobj}
        footerImg={
          HandlerType === "view" ? <AddDocumentsillus /> : <AddDocumentsillus />
        }
        onReceiveProps={onReceivePropsHandler}
      />
    </div>
  );
};

const ComponentRenderData = (props) => {
  const [imgList, setImgList] = useState([]);
  const [imgData, setImgData] = useState([]);
  const [isUploaded, setIsUploaded] = useState(true);
  const [disableSubmitBtn, setDisableSubmitBtn] = React.useState(true);
  const [docUrl, setDocUrl] = useState(null);
  const [docType, setDocType] = useState(null);
  const [sourceModelValues, setSourceModelValues] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [sourced, setSourced] = useState(null);
  const [showSourcedfrom, setShowSourcedfrom] = useState(false);
  const [pdfSrc, setPdfSrc] = useState(null);

  const fileType = "jpg not supported";
  const dispatch = useDispatch();

  const UploadDocCode = useSelector((state) => state.UploadDocuments.data);
  const customFieldsData = useSelector((state) => state.CustomFields.data);

  useEffect(() => {
    setPdfSrc(docUrl || null);
  }, [docUrl]);

  useEffect(() => {
    if (props.previewType !== "") {
      setDocUrl(props.previewType);
    }
  }, [props.previewType]);

  useEffect(() => {
    if (imgData.length === 0 && imgList.length === 0) {
      setIsUploaded(true);
    }
  }, [imgData, imgList]);

  const onRemoveItem = (item) => {
    let imgNames = JSON.parse(JSON.stringify(imgList));
    let findIndex = imgNames.findIndex((x) => x.id === item.id);
    if (findIndex !== -1) {
      imgNames.splice(findIndex, 1);
      imgData.splice(findIndex, 1);
      setImgList(imgNames);
    }
    imgData.splice(parseInt(item.id), 1);
    setImgData(imgData);
  };

  const fileImgHandler = (event) => {
    let files = event.target.files;
    let imgNames = JSON.parse(JSON.stringify(imgList));
    let imgObj = JSON.parse(JSON.stringify(imgData));
    var fileInput = document.getElementById("fileId");
    let extension = files[0].name.substring(files[0].name.lastIndexOf("."));
    var filePath = fileInput.value || extension;
    var allowedExtensions = /(\.doc|\.docx|\.pdf)$/i;
    if (!allowedExtensions.exec(filePath)) {
      dispatch(
        updateSnackbar({
          type: "error",
          message:
            "Invalid file format. Please upload a Doc, Pdf, or Docx file",
        }),
      );
      fileInput.value = "";
      return false;
    } else {
      let tempImgNames = [],
        tempImgObj = [];
      for (var i = 0; i < files.length; i++) {
        if (files[i].size > MAX_FILE_SIZE_BYTES) {
          dispatch(
            updateSnackbar({
              type: "error",
              message: `File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload a smaller file.`,
            }),
          );
          continue;
        }
        let obj = { id: Date.now() + i, name: files[i].name };
        tempImgNames.push(obj);
        tempImgObj.push(files[i]);
      }
      imgNames.push(...tempImgNames);
      imgObj.push(...tempImgObj);
      setImgList(imgNames);
      setIsUploaded(false);
      setImgData(imgObj);
    }
    event.target.value = "";
  };

  const uploadDocuments = async () => {
    if (
      docType === "Resume"
        ? docType && sourced && imgList.length !== 0
        : docType && imgList.length !== 0
    ) {
      setDisableSubmitBtn(true);

      const userInfo = await getUserDetails();

      let formData = new FormData();
      let checkFileType = imgData.filter(
        (elem) =>
          elem.name.match(/jpg/) ||
          elem.name.match(/png/) ||
          elem.name.match(/jpeg/) ||
          elem.name.match(/JPEG/) ||
          elem.name.match(/SVG/) ||
          elem.name.match(/gif/),
      );
      if (checkFileType.length > 0) {
        alert("file does not support");
      } else {
        for (let i = 0; i < imgData.length; i++) {
          formData.append("Resume", imgData[i]);
        }
        formData.append("id", props.JobId);
        formData.append("userId", userInfo.userId);
        formData.append("DbUserId", userInfo.id);
        formData.append("ResumeUserId", userInfo.id);
        formData.append("fileType", docType);
        formData.append("resumesourceId", sourced?.id ? sourced.id : "");
        formData.append("resumesource", sourced?.name ? sourced.name : "");
        formData.append("userFirstName", userInfo.firstName);
        formData.append("userLastName", userInfo.lastName);
        dispatch(_ser.uploadDocumentsAsync(props.JobId, formData, true))
          .then(() => {
            setDisableSubmitBtn(false);
          })
          .catch(() => {
            setDisableSubmitBtn(false);
          });
      }
    } else {
      dispatch(
        updateSnackbar({ type: "error", message: "All fields are required" }),
      );
    }
  };

  useEffect(() => {
    if (UploadDocCode === 200 || UploadDocCode === 208) {
      dispatch(_ser.uploadDocumentsStartReducer(initalState));
      props.onReceivechildProps(false, true, null);
    }
  }, [UploadDocCode]);

  useEffect(() => {
    if (docType === "Resume") {
      setShowSourcedfrom(true);
    } else {
      setShowSourcedfrom(false);
      setSourced(null);
    }
    if (
      docType === "Resume"
        ? docType && sourced && imgList.length !== 0
        : docType && imgList.length !== 0
    ) {
      setDisableSubmitBtn(false);
    } else {
      setDisableSubmitBtn(true);
    }
  }, [docType, sourced, imgList]);

  useEffect(() => {
    async function init() {
      let userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let overrideDefaultPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "2" && x.fieldType === "default",
      );
      if (overrideDefaultPostingFieldsData.length > 0) {
        overrideDefaultPostingFieldsData.forEach((list) => {
          if (list.fieldName === "Source") {
            let updatedCustomValues = JSON.parse(list.customValues);
            let modifiedCustomValues = [];
            updatedCustomValues.forEach((list) => {
              if (
                list !== "Cloud Sourcing" &&
                list !== "Employee Portal" &&
                list !== "Vendor Sourcing" &&
                list !== "Job Board Portal"
              ) {
                modifiedCustomValues.push(list);
              }
            });
            setSourceModelValues(modifiedCustomValues);
          } else if (list.fieldName === "Document type") {
            let documentTypeOptions = JSON.parse(list.customValues);
            documentTypeOptions.push("Other");
            setDocumentTypeOptions(documentTypeOptions);
          }
        });
      }
    }
  }, [customFieldsData]);

  useEffect(() => {
    let defaultPostingModules = defaultApplicantsData.filter(
      (x) => x.moduleId.toString() === "2",
    );
    if (defaultPostingModules.length > 0) {
      defaultPostingModules.forEach((list) => {
        if (list.fieldName === "Source") {
          setSourceModelValues(list.customValues);
        }
      });
    }
  }, []);
  if (props.handler === "New document") {
    return (
      <>
        <div className="choosedocument">
          <FormControl fullWidth autoComplete="off" variant="outlined">
            <InputLabel className="boldSelectlabel" shrink={true}>
              Choose Document*
            </InputLabel>

            <Autocomplete
              fullWidth
              options={documentTypeOptions}
              value={docType}
              onChange={(event, newValue) => {
                setDocType(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  className="boldSelectlabel"
                />
              )}
              getOptionLabel={(option) => option || ""}
              className="choosedocumentinput"
            />
          </FormControl>

          {showSourcedfrom && (
            <FormControl
              fullWidth
              autoComplete="off"
              variant="outlined"
              style={{ marginTop: "35px" }}
            >
              <InputLabel className="boldSelectlabel" shrink={true}>
                Sourced from *
              </InputLabel>
              <Autocomplete
                fullWidth
                options={sourceModelValues}
                value={sourced ? sourced.name : null}
                onChange={(event, newValue) => {
                  if (newValue) {
                    const index = sourceModelValues.indexOf(newValue);
                    setSourced({ id: (index + 1).toString(), name: newValue });
                  } else {
                    setSourced(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="boldSelectlabel"
                  />
                )}
                getOptionLabel={(option) => option || ""}
                className="sourcedfrominput"
              />
            </FormControl>
          )}
        </div>
        {isUploaded ? (
          <>
            <div className="uploadfileicon">
              <img
                src={process.env.PUBLIC_URL + "/assests/img/uploadBgIcon.svg"}
                alt=""
              />
            </div>
            <Button
              variant="contained"
              component="label"
              className="appuploadresume"
              disabled={imgList.length > 0}
            >
              <span>
                <b style={{ color: "var(--primary-bg-color)" }}>Upload</b>
                <b style={{ color: "#9E9E9E" }}> browse file to upload </b>
              </span>
              <input
                hidden
                accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                type="file"
                id="fileId"
                onChange={(e) => fileImgHandler(e)}
              />
            </Button>
            <p className="docsupporttext">
              Supported file formats: Doc, Pdf, Docx{" "}
            </p>
          </>
        ) : (
          ""
        )}
        {imgList.length > 0 ? (
          <ul className="listofUploads">
            {imgList &&
              imgList.map((list) => {
                return (
                  <li key={list.id}>
                    <p>{list.name}</p>
                    <p>
                      {list.name.match(".jpg") ||
                      list.name.match(".png") ||
                      list.name.match(/jpg/) ||
                      list.name.match(/png/) ||
                      list.name.match(/jpeg/) ||
                      list.name.match(/JPEG/) ||
                      list.name.match(/SVG/)
                        ? fileType
                        : ""}
                    </p>
                    <span
                      className="closeImgbtn"
                      onClick={() => onRemoveItem(list)}
                    >
                      <DeleteOutlineIcon />
                    </span>
                  </li>
                );
              })}
          </ul>
        ) : (
          ""
        )}
        <div className="actionBtns">
          <Button
            type="button"
            className="cancelBtn"
            size="small"
            onClick={() => {
              props.onReceivechildProps(false, "close");
            }}
          >
            <span
              style={{ color: "red", fontSize: "14px", textDecoration:'underline' }}
            >
              {" "}
              Cancel
            </span>
          </Button>
          <Button
            type="button"
            variant="contained"
            className="saveBtn"
            onClick={uploadDocuments}
            size="small"
          >
            Save
          </Button>
        </div>
      </>
    );
  } else if (props.handler === "view") {
    const ext = (props.fileExtention || "").toLowerCase();
    return (
      <DocumentViewer
        url={props.previewType}
        fileType={ext}
        onDownload={() => {
          props.onReceivechildProps(
            { path: props.DocName, fileType: props.fileExtention },
            "",
            "download",
          );
        }}
      />
    );
  }
};
export default AddApplicantDetailsDocuments;

const pannelobj = {
  title: "Add documents",
  description: "Select Document Type",
  bgImage: "",
};

const pannelobjview = {
  title: "Document view",
  description: "",
  bgImage: "",
};
